import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHero = ({ title, eyebrow, breadcrumbs = [] }) => {
  return (
    <section className="pt-page-hero">
      <div className="max-w-[1320px] mx-auto px-6 relative z-10">
        <div className="crumbs flex flex-wrap items-center gap-2">
          <Link to="/" className="hover:text-[#d4b673]">Home</Link>
          {breadcrumbs.map((b, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight size={12} className="text-[#c9a961]" />
              {b.path ? <Link to={b.path} className="hover:text-[#d4b673]">{b.label}</Link> : <span className="text-white">{b.label}</span>}
            </span>
          ))}
        </div>
        {eyebrow && <div className="mt-6 eyebrow-gold">{eyebrow}</div>}
        <h1>{title}</h1>
      </div>
    </section>
  );
};

export default PageHero;
